module.exports = __webpack_public_path__ + "static/esenses-aab52497757d893474b305d4d5d52025.png";